import { render, staticRenderFns } from "./Supplierresearch.vue?vue&type=template&id=0e60b2f8&"
import script from "./Supplierresearch.vue?vue&type=script&lang=js&"
export * from "./Supplierresearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports